import React from 'react';
import { Box, Flex, Alert, AlertIcon } from "@chakra-ui/react";
import { IoIosTrash, IoMdImage } from "react-icons/io";
import config from "../../../config/app-config";
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import ImageUploading from 'react-images-uploading';
import './image-uploader.css'

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/pagination';


// TODO: This component is extremely messy. Refactor when capacity allows.
const DsrPostImagesUpload = ({ getFiles, isProcessing }) => {

  const [images, setImages] = React.useState([]);
  const { maxImageFileUploadLimit, maxImageFileSize, acceptedImageFileTypes } = config;
  

  const maxSingleFileSizeInMb = Math.trunc(maxImageFileSize / (1024 * 1024));
  const maxNumber = maxImageFileUploadLimit;
  const maxFileSize = maxImageFileSize;
  
  const onChange = (imageList, addUpdateIndex) => {
    let allFiles = imageList.map(item => item.file)
    getFiles(allFiles, "images")
    setImages(imageList);
  };

  return (
    <Box w='100%' mx='1em'>
      <Box px='1em' pb='1em'>
        <ImageUploading
          multiple
          maxFileSize={maxFileSize}
          value={images}
          onChange={onChange}
          acceptType={acceptedImageFileTypes}
          maxNumber={maxNumber}
          dataURLKey="data_url"
        >
          {({
            imageList,
            onImageUpload,
            errors,
            onImageRemove,
            isDragging,
            dragProps,
          }) => (

            <Box>
              {imageList.length === 0 ?
                <button
                  className="drop-area"
                  style={isDragging ? { color: 'red' } : undefined}
                  onClick={onImageUpload}
                  {...dragProps}
                >

                  <Flex className="drop-area-title" direction='column' justify='center' align='center' fontSize='1em' textAlign='center'>
                    <Box mb='2em'><Box fill='brandDark.500' as={IoMdImage} width="48px" height="3.5em" /></Box>
                    <LaunchdeckButton bg='brandDark.500' color='white' px='2em' fontSize='0.8em' label='Select image(s)' />
                  </Flex>
                  <Flex direction='column' mt='2em' fontSize='0.75em' >

                    <Flex justify='space-around' align='center' gap={'3.5em'}>
                      <Box>
                        <Box mt='0.75em' color='gray.500' textAlign='center'>
                          Max images
                        </Box>
                        <Box textAlign='center' mt='0.5em' fontWeight='600'>
                          {maxNumber}
                        </Box>
                      </Box>

                      <Box>
                        <Box mt='0.75em' color='gray.500' textAlign='center'>
                          Max size
                        </Box>
                        <Box textAlign='center' mt='0.5em' fontWeight='600'>
                          {maxSingleFileSizeInMb}MB each
                        </Box>

                      </Box>


                      <Box>

                        <Box mt='0.75em' color='gray.500' textAlign='center'>
                          Formats
                        </Box>
                        <Box textAlign='center' mt='0.5em' fontWeight='600'>
                          JPEG, JPG, PNG
                        </Box>


                      </Box>
                    </Flex>

                    {errors &&
                      <div className='error-list'>

                        {errors.maxNumber ?
                          <Alert px='1em' status="error" variant="solid" bg='brandPink.500' rounded='0.25em' color='white'>
                            <AlertIcon boxSize='1em' />
                            <Box>  Max image limit: {maxNumber}</Box>
                          </Alert>

                          : errors.maxFileSize ?
                            <Alert px='1em' status="error" variant="solid" bg='brandPink.500' rounded='0.25em' color='white'>
                              <AlertIcon boxSize='1em' />
                              <Box> Upload size limit: {maxSingleFileSizeInMb}MB per image</Box>
                            </Alert>


                            : ""}
                      </div>}
                  </Flex>
                </button>
                :
                imageList.length > 0 &&
                <Box>
                  <Swiper className='mySwiper'
                    pagination={{
                      dynamicBullets: true,
                    }}
                    modules={[Pagination]}>
                    {imageList.map((image, index) => (
                      <SwiperSlide key={index} className="swiper-slide">
                        <img
                          src={image['data_url']} alt={""}
                          style={{ maxHeight: "400px", width: "auto", display: "block", margin: "0 auto" }}
                        />
                        <div
                          style={{
                            cursor: 'pointer',
                            position: "absolute",
                            top: 3,
                            right: 10,
                            backgroundColor: "grey",
                            color: "white",
                            borderRadius: "50%",
                            width: 25,
                            height: 25,
                            display:  isProcessing ? "none" : "flex",
                            alignItems: "center",
                            justifyContent: "center"
                          }}
                          onClick={() => {
                            !isProcessing && onImageRemove(index);
                          }}
                        >
                          <IoIosTrash size={18} />
                        </div>


                      </SwiperSlide>
                    ))}
                  </Swiper>
                </Box>
              }
              {/* {errors &&
                <div className='error-list'>

                  {errors.maxNumber ? <><RiErrorWarningLine color="red" size={20} /> &nbsp; You can
                    upload only {maxImageFileUploadLimit} images per post</> : errors.maxFileSize ? <><RiErrorWarningLine
                      color="red" size={20} /> &nbsp; Upload limit is 2MB per image</> : ""}
                </div>} */}

            </Box>
          )}
        </ImageUploading>
      </Box>
    </Box>
  );
};

export default DsrPostImagesUpload;
